/**
 * @param {import('../types').StateChangeEventInit} eventInit
 */
export const eventStateChange = eventInit => new CustomEvent('statechange', eventInit);
